import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    "& > div": {
      top: 0,
      paddingBottom: theme.hv.spacing.lg,
    },
  },
  sectionMargin: {
    marginTop: 64,
    outline: "none",
  },
  loading: {
    position: "fixed",
    left: 0,
    top: 0,
    width: "100%",
    height: "100vh",
  },
  zIndex: {
    // We need to set this nonsense value to make sure the loading overlays all HVS page elements.
    zIndex: 9999999999,
  },
  bannerRoot: {
    position: "absolute",
  },
  sectiomMarginOverride: {
    marginTop: "79px",
  },
  sectionMarginCondition: {
    marginTop: "32px",
  },
}));

export default useStyles;
